import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { LoaderService } from '@services/loader.service';
import { finalize, Observable, tap } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requestsCount = 0;
  private readonly urlsBlacklist: string[] = [
    `${environment.apiUrl}/komunikacja/wiadomosci/wiadomosci-odebrane/liczba-nieodebranych-wiadomosci`,
    `${environment.apiUrl}/studia/platforma-administracyjna/osoby/zdjecia`,
    `${environment.apiUrl}/finanse/platforma-administracyjna/osoby/zdjecia`,
  ];
  private readonly urlsWhitelist = [environment.apiUrl];

  constructor(private readonly loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<Record<string, unknown>>,
    next: HttpHandler,
  ): Observable<HttpEvent<Record<string, unknown>>> {
    if (
      !this.urlsBlacklist.some((url) => request.url.includes(url)) &&
      this.urlsWhitelist.some((url) => request.url.includes(url))
    ) {
      return next.handle(request).pipe(
        tap({
          next: (v) => {
            if (v.type === HttpEventType.Sent) {
              if (this.requestsCount === 0) {
                this.loaderService.show();
              }
              this.requestsCount++;
            }
          },
        }),
        finalize(() => {
          this.requestsCount--;
          if (this.requestsCount === 0) {
            this.loaderService.hide();
          }
        }),
      );
    }
    return next.handle(request);
  }
}
